// TODO: dry up models
export default class BaseModel {
  static cleanParam(name = '') {
    if (!name) {
      return '';
    }
    return name.split('?')[0];
  }
}



// WEBPACK FOOTER //
// ./src/models/base_model.js